import InventoriesApi from '../../apis/Inventories';

export default {
    namespaced: true,
    state: {
        inventories: [],
        product_selected: null,
        kardex: [],
        inventory_response: null,
        inventory_selected: {}
    },
    mutations: {
        set_inventories (state, data) {
            state.inventories = data;
        },
        set_product_selected (state, data) {
            state.product_selected = data;
        },
        set_kardex (state, data) {
            state.kardex = data;
        },
        set_inventory_response (state, value) {
            state.inventory_response = value;
        },
        set_inventory_selected (state, data) {
            state.inventory_selected = data;
        },
        replace_inventory_item (state, data) {
            state.inventories.splice(data.index, 1, data.item);
        }
    },
    actions: {
        setInventorySelected ({commit}, data) {
            commit('set_inventory_selected', data);
        },
        replaceInventoryItem ({commit}, data) {
            commit('replace_inventory_item', data);
        },
        async getInventory({commit}, filters) {
            return await InventoriesApi.get_all(filters)
                .then( response => {
                    commit('set_inventories', response.data)
                })
                .catch( error => {
                    commit('set_inventory_response', 'error');
                })
        },
        async store({commit, dispatch}, data) {
            commit('set_inventory_response', null);
            return await InventoriesApi.store(data)
                .then( response => {
                    commit('set_inventory_response', 'success');
                    dispatch('getInventory');
                })
                .catch( error => {
                    commit('set_inventory_response', 'error');
                })
        },
        setProductSelected ({commit}, data) {
            commit('set_product_selected', data);
        },
        async getkardex ({commit}, filters) {
            return await InventoriesApi.get_kardex(filters)
                .then( response => {
                    commit('set_kardex', response.data)
                })
                .catch( error => {
                    console.log(error);
                })
        },
    }
}